


































import Vue from "vue"
import ColumnWithIcon from "~/components/guideline/util/ColumnWithIcon.vue"
import LinkColumnWithImage from "~/components/guideline/util/LinkColumnWithImage.vue"
import { LOCATION_ICON, LINK_ICON } from "~/config/icon"

export default Vue.extend({
  components: {
    ColumnWithIcon,
    LinkColumnWithImage,
  },
  props: {
    corporationProfileUrl: {
      type: String,
      default: "",
    },
    corporationName: {
      type: String,
      required: true,
    },
    corporationAddress: {
      type: String,
      required: true,
    },
    corporationWebsiteUrl: {
      type: String,
      required: true,
    },
    corporationLogoImageUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      return { LOCATION_ICON, LINK_ICON }
    },
  },
})
